// extracted by mini-css-extract-plugin
export var arrows = "_92-6";
export var decrementer = "_92-a";
export var disabled = "_92-4";
export var error = "_92-1";
export var hiddenText = "_92-b";
export var incrementer = "_92-9";
export var input = "_92-8";
export var inputWrapper = "_92-0";
export var leadingIcon = "_92-c";
export var readonly = "_92-3";
export var regular = "_92-7";
export var small = "_92-5";
export var warning = "_92-2";